import { render } from "./CreateMemo.vue?vue&type=template&id=4062cec6"
import script from "./CreateMemo.vue?vue&type=script&lang=js"
export * from "./CreateMemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__